import { useTranslation } from '@framework/i18n';
import { SpidLoginButton } from './SpidLoginButton';

export interface IProfessionalSpidLoginButtonProps {
  resolvePublicUrl: (path: string) => string;
  fullWidth?: boolean;
}

export function ProfessionalSpidLoginButton(
  props: IProfessionalSpidLoginButtonProps,
) {
  const { t } = useTranslation();

  return (
    <SpidLoginButton
      {...props}
      purpose="PX"
      text={t(
        'user.login.spid-professional-button',
        'Entra con SPID Professionale',
      )}
    />
  );
}
